export default __webpack_public_path__ + "static/media/Icon.79cd666d.svg";